module.exports = __webpack_public_path__ + "static/media/certificate.d7b11520.svg";